import React, { useMemo } from 'react';
import ButtonsListItemContent from './buttons-list-item.content';
import { useParamsContext } from '../../../../params/params-context';
import { ButtonListDataItem } from '../../buttons-list.data';
import { PORTAL_TYPE, ACTIVE_ICON } from '../../../../types/app.types';
import useDispatchButton from '../../../../hooks/use-dispatch-button.hook';

interface ButtonsListItemProps {
  item: ButtonListDataItem;
}

const ButtonsListItem: React.FunctionComponent<ButtonsListItemProps> = ({
  item
}) => {
  const { portalType, activeIcon } = useParamsContext();
  const { onClickHandler } = useDispatchButton(item);

  const isGreyed = useMemo(() => {
    if (activeIcon === ACTIVE_ICON.ALL) {
      return false;
    }
    if (activeIcon === item.id) {
      return false;
    }
    if (activeIcon || activeIcon === ACTIVE_ICON.NONE) {
      return true;
    }
    return (
      (portalType === PORTAL_TYPE.UMER && item.id !== PORTAL_TYPE.UMER) ||
      (portalType === PORTAL_TYPE.FMER && item.id !== PORTAL_TYPE.ER1) ||
      (portalType === PORTAL_TYPE.ER1 && item.id !== PORTAL_TYPE.ER1) ||
      (portalType === PORTAL_TYPE.ERDE && item.id !== PORTAL_TYPE.FMER)
    );
  }, [item.id, portalType, activeIcon]);

  return (
    <ButtonsListItemContent
      item={item}
      onClickHandler={onClickHandler}
      isGreyed={isGreyed}
    />
  );
};

export default ButtonsListItem;
